import type { GalaxyData, StarSystem } from "../types";
import systemsJson from "./systems.json";

const data = systemsJson as GalaxyData;

export function loadSystems(): StarSystem[] {
  return data.systems;
}

export function getSystem(id: string): StarSystem | undefined {
  return data.systems.find((s) => s.id === id);
}

export function systemsByDangerTier(tier: 0 | 1 | 2 | 3 | 4): StarSystem[] {
  return data.systems.filter((s) => s.dangerTier === tier);
}
